module.exports = __webpack_public_path__ + "img/logo.86b45d65.svg";